import { createGatsbyPageComponent } from '@shapeable/ui';
import { graphql } from 'gatsby';
export default createGatsbyPageComponent('Page');

export const QUERY = graphql`
query PageQuery($id: ID!) {
  platform { page(id: $id) {
    id name slug typeLabel badge path updated __typename _schema { label pluralLabel }  
    title 
    pretitle
    subtitle
    titleRich { text }
    subtitleRich { text }
    published
    content { text }
    options { text }
    openGraph { title description { plain } image { url url2x thumbnails { card { url url2x } bubble { url url2x } } } }
    intro { plain text }
    outro { text }
    orderNumber
    themeMode { slug }
    bannerThemeMode { slug }
    layout {
      id name slug component 
    }
    videos {
      id name url
      thumbnail { id url url2x }
    }
    imageAssets {
      id name image { id url url2x type }
    }
    people {
      id name slug path
      organisation { id name }
      linkedin
      position
      photo { id url url2x type }
    }
    bannerLinks {
      id name slug url typeLabel __typename
      type { id name }
      label
      bannerTitle
      bannerTitleRich { text }
      bannerSubtitle
      bannerSubtitleRich { text }
      openGraph { id image { id url thumbnails { card { url url2x } } } }
      banner {
        id name slug
        image { id url url2x width height thumbnails { halfBanner { url url2x } mainBanner { url url2x } } }
        description { text }
      }
      page { 
        id name slug path __typename 
        type { id name }
        title
        subtitle
        openGraph { id image { id url url2x } }
      }
      post { 
        id name slug path __typename 
        typeLabel
        title
        subtitle
        openGraph { id image { id url url2x } }
      }
    }
    embeds {
      citations {
        slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year
      }
      pages {
        id name slug path
        openGraph {
          title description { plain }
          image { url url2x type }
        }
      }
      people {
        id name slug path
        organisation { id name }
        position
        photo { id url }
      }
      imageAssets {
        id
        slug
        image {
          id url url2x type width height 
        }
      }
    }
    
    parent {
      __typename id name path slug title subtitle pretitle 
      content { text }
      children {
        __typename id name path slug title subtitle pretitle 
        openGraph { description { text } }
        intro { text }
        orderNumber
        banner {
          name slug alternateText
          thumbnail { 
            id url url2x width height
          }
        }
      }
    }
    
    children {
      __typename id name path slug title subtitle pretitle 
      openGraph { description { text } }
      intro { text }
      orderNumber
      banner {
        name slug alternateText
        thumbnail { 
          id url url2x width height
        }
      }
    }
    themeMode { slug }
    bannerThemeMode { slug }
    banners {
      id name slug title description { text } alternateText
      image { 
        id url url2x type width height
      }
    }
    slices {
      id name slug 
      title
      disabled
      created updated
      outro { text }
      intro { text }
      titleRich { text }
      subtitleRich { text }
      themeMode { slug }
      images {
        id name slug alternateText description { text }
        image { 
          id url url2x type width height 
        }
      }
      links {
        id name __typename
        description { text }
        color { id value slug }
        banner {
          id name slug
          image { id url url2x width height thumbnails { halfBanner { url url2x } mainBanner { url url2x } } }
        }
        file { 
          id name slug
          file { id url extension }
        }
        openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
      }
      pages {
        id name path disabled
      }
      people {
        __typename
        id name slug 
        photo { url url2x type }
        position
        bio { text html(links: { target: "_blank" }) }
        linkedin
        organisation { id name }
      }
      links {
        id name url page { path }
      }
      options { text }
      files {
        id
        name
        slug
        file {
          id
          url
        }
        thumbnail {
          url url2x
        }
      }
      videos { 
        url 
        openGraph {
          image { url url2x type }
        }
      }
      color { value }
      backgroundColor { value }
      backgroundImages {
        image {
          url url2x
        }
      }
      blocks {
        id name slug 
        title 
        titleRich { text }
        subtitle
        subtitleRich { text }
        link { id url name page { path } }
        page { id path name }
        links { id url name page { path } }
        pages { id name }
        content { text }
        options { text }
        image { id name image { url url2x type } }
      }
      content { text }
      image { id }
      layout { id name slug component themeMode { slug } }
      organisations {
        id
        name
        url
        logoInverted { type url url2x }
        logo { type url url2x }
      }
    }
  } }
}
`;
